export default "__VITE_ASSET__d86cbc54__"